import {ConditionBase} from "./ConditionBase";
import * as React from "react";

export class NoneCondition extends ConditionBase{
    GetComparisons(): { Label: string; Value: string }[] {
        return [];
    }

    GetValueEditor(): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
        return (
            <div className={'rncontrol'}>
                <label/>
                <input style={{width:'100%'}} type={'text'} disabled={true}/>
            </div>

        )
    }

}